var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wh-100"},[_c('nk-table',{staticClass:"table-border",attrs:{"id":"table","data":_vm.tableData,"noDataTitle":'该时间段暂无数据',"columns":_vm.columns,"border":true,"rowselect":true,"arraySpanMethod":_vm.objectSpanMethod}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }